import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { CART_URL } from '../data/content';
interface CTAButtonProps {
  children: React.ReactNode;
  size?: 'md' | 'lg';
  className?: string;
}
export function CTAButton({
  children,
  size = 'lg',
  className = ''
}: CTAButtonProps) {
  const sizing = size === 'lg' ? 'px-8 py-4 text-base sm:text-lg' : 'px-6 py-3 text-sm sm:text-base';
  return <a href={CART_URL} className={`group inline-flex items-center justify-center gap-2 rounded-full bg-green-brand font-sans font-extrabold uppercase tracking-wide text-white shadow-lg shadow-green-brand/30 transition-all duration-200 hover:-translate-y-0.5 hover:bg-green-deep hover:shadow-xl hover:shadow-green-brand/40 focus:outline-none focus:ring-4 focus:ring-green-brand/30 ${sizing} ${className}`} data-id="element-29" data-mp="2tyb76tcbgalr">
      <span data-id="element-30" data-mp="3cqdtak7q8j3e">{children}</span>
      <ArrowRightIcon className="h-5 w-5 transition-transform duration-200 group-hover:translate-x-1" data-id="element-31" data-mp="3cnhvqwzsjwfh" />
    </a>;
}